import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  template: `
    <div class="page-header">
      <div class="page-header__text">
        <h1 class="page-header__title">{{ title }}</h1>
        <span *ngIf="subtitle" class="page-header__subtitle">{{ subtitle }}</span>
      </div>
      <div class="page-header__actions">
        <ng-content></ng-content>
      </div>
    </div>
  `
})
export class PageHeaderNewComponent {
  @Input() title = '';
  @Input() subtitle = '';
}
